'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var react = require('react'); // original: https://usehooks.com/useScript/


function useScript(src) {
  // Keep track of script status ("idle", "loading", "ready", "error")
  var _react$useState = react.useState(src ? 'loading' : 'idle'),
      _react$useState2 = _slicedToArray(_react$useState, 2),
      status = _react$useState2[0],
      setStatus = _react$useState2[1];

  react.useEffect(function () {
    // Allow falsy src value if waiting on other data needed for
    // constructing the script URL passed to this hook.
    if (!src) {
      setStatus('idle');
      return;
    } // Fetch existing script element by src
    // It may have been added by another intance of this hook


    var script = document.querySelector("script[src=\"".concat(src, "\"]"));

    if (!script) {
      // Create script
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-status', 'loading'); // Add script to document body

      document.body.appendChild(script); // Store status in attribute on script
      // This can be read by other instances of this hook

      var setAttributeFromEvent = function setAttributeFromEvent(event) {
        script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
      };

      script.addEventListener('load', setAttributeFromEvent);
      script.addEventListener('error', setAttributeFromEvent);
    } else {
      // Grab existing script status from attribute and set to state.
      setStatus(script.getAttribute('data-status'));
    } // Script event handler to update status in state
    // Note: Even if the script already exists we still need to add
    // event handlers to update the state for *this* hook instance.


    var setStateFromEvent = function setStateFromEvent(event) {
      setStatus(event.type === 'load' ? 'ready' : 'error');
    }; // Add event listeners


    script.addEventListener('load', setStateFromEvent);
    script.addEventListener('error', setStateFromEvent); // Remove event listeners on cleanup

    return function () {
      if (script) {
        script.removeEventListener('load', setStateFromEvent);
        script.removeEventListener('error', setStateFromEvent);
      }
    };
  }, [src] // Only re-run effect if script src changes
  );
  return status;
}

var RECAPTCHA_SCRIPT_SRC_URL = 'https://www.google.com/recaptcha/api.js?render=explicit';
var timer;
/**
 * a hook integrates google-recaptcha v2 into react function components
 * @param {Object} config configuration of recaptcha
 * @param {string} config.containerId  ID of the container to render the recaptcha widget
 * @param {string} config.sitekey client-side sitekey
 * @param {string} config.size the size of the widget. Value can be either of "normal", "compact", "invisible"
 * @param {string} config.theme The color theme of the widget. Value can be either of "dark" or "light". This is only applicable to checkbox recaptcha
 * @param {string} config.badge Reposition the recaptcha badge. Value can be either of "bottomright", "bottomleft", 'inline'. 'inline' lets you position it with CSS. This is only applicable to invisible recaptcha
 * @param {Function} config.successCallback executed when the user submits a successful response and passes the challenge if it prompts up. The g-recaptcha-response token is passed to the callback.
 * @param {Function} config.expiredCallback executed when the recaptcha response expires and the user needs to re-verify.
 * @param {Function} config.errorCallback executed when recaptcha encounters an error (usually network connectivity) and cannot continue until connectivity is restored. If you specify a function here, you are responsible for informing the user that they should retry.
 * @return {Object}
 */

function useRecaptcha(_ref) {
  var _window, _window$grecaptcha;

  var containerId = _ref.containerId,
      sitekey = _ref.sitekey,
      size = _ref.size,
      theme = _ref.theme,
      successCallback = _ref.successCallback,
      expiredCallback = _ref.expiredCallback,
      errorCallback = _ref.errorCallback; // https://stackoverflow.com/questions/45240833/what-are-the-benefits-of-explicitly-rendering-recaptcha-widget-as-opposed-to-aut
  // explicit rendering is needed because the view template of applicatio may not be loaded yet when recaptcha is loaded

  useScript(RECAPTCHA_SCRIPT_SRC_URL);

  var _react$useState3 = react.useState((_window = window) !== null && _window !== void 0 && (_window$grecaptcha = _window.grecaptcha) !== null && _window$grecaptcha !== void 0 && _window$grecaptcha.render ? true : false),
      _react$useState4 = _slicedToArray(_react$useState3, 2),
      recaptchaLoaded = _react$useState4[0],
      setRecaptchaLoaded = _react$useState4[1];

  var _react$useState5 = react.useState(null),
      _react$useState6 = _slicedToArray(_react$useState5, 2),
      recaptchaWidget = _react$useState6[0],
      setRecaptchaWidget = _react$useState6[1];

  react.useEffect(function () {
    timer = window.setInterval(function () {
      var _window2, _window2$grecaptcha;

      if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$grecaptcha = _window2.grecaptcha) !== null && _window2$grecaptcha !== void 0 && _window2$grecaptcha.render) {
        setRecaptchaLoaded(true);
      }
    }, 500);
    return function () {
      clearInterval(timer);
    };
  }, []);
  react.useEffect(function () {
    if (recaptchaLoaded && recaptchaWidget === null) {
      clearInterval(timer);
      var widget = window.grecaptcha.render(containerId, {
        sitekey: sitekey,
        size: size,
        theme: theme,
        callback: successCallback,
        'expired-callback': expiredCallback,
        'error-callback': errorCallback
      });
      setRecaptchaWidget(widget);
    }
  }, [recaptchaLoaded, successCallback, recaptchaWidget, containerId]);
  return {
    recaptchaLoaded: recaptchaLoaded,
    recaptchaWidget: recaptchaWidget
  };
}

exports.RECAPTCHA_SCRIPT_SRC_URL = RECAPTCHA_SCRIPT_SRC_URL;
exports.useRecaptcha = useRecaptcha;